"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3230],{

/***/ 15445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./public/dawn-logo.svg
var dawn_logo = __webpack_require__(54171);
// EXTERNAL MODULE: ./components/icons/IconFacebook.tsx
var IconFacebook = __webpack_require__(12337);
// EXTERNAL MODULE: ./components/icons/IconTwitter.tsx
var IconTwitter = __webpack_require__(22971);
;// CONCATENATED MODULE: ./components/icons/IconInstagram.tsx

function IconInstagram(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "none",
        viewBox: "0 0 24 24",
        className: "fill-current ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.053.072C8.333.013 8.74 0 12 0s3.668.014 4.946.072c1.279.058 2.151.262 2.915.557.8.303 1.525.775 2.125 1.386a5.862 5.862 0 011.383 2.124c.297.764.5 1.636.559 2.913C23.987 8.333 24 8.742 24 12c0 3.26-.014 3.668-.072 4.947-.058 1.277-.262 2.15-.559 2.913a5.887 5.887 0 01-1.383 2.126 5.885 5.885 0 01-2.125 1.383c-.764.297-1.636.5-2.913.559-1.28.059-1.688.072-4.948.072-3.26 0-3.668-.014-4.947-.072-1.277-.058-2.15-.262-2.913-.559a5.889 5.889 0 01-2.126-1.383 5.882 5.882 0 01-1.385-2.125c-.295-.764-.498-1.636-.557-2.913C.013 15.666 0 15.258 0 12c0-3.26.014-3.668.072-4.946.058-1.279.262-2.151.557-2.915.302-.8.775-1.526 1.386-2.125A5.882 5.882 0 014.139.629C4.903.334 5.775.131 7.052.072zm9.796 2.16c-1.265-.058-1.645-.07-4.849-.07s-3.584.012-4.85.07c-1.17.053-1.805.249-2.228.413-.56.219-.96.477-1.38.897a3.722 3.722 0 00-.897 1.38c-.164.423-.36 1.058-.413 2.229-.058 1.265-.07 1.645-.07 4.849s.012 3.584.07 4.85c.053 1.17.249 1.804.413 2.228.192.52.499.992.897 1.38.387.398.86.705 1.38.897.423.164 1.058.36 2.229.413 1.265.058 1.644.07 4.849.07s3.584-.012 4.85-.07c1.17-.053 1.804-.249 2.228-.413.56-.219.96-.477 1.38-.897.398-.387.705-.86.897-1.38.164-.424.36-1.058.413-2.229.058-1.265.07-1.645.07-4.849s-.012-3.584-.07-4.85c-.053-1.17-.249-1.805-.413-2.228a3.725 3.725 0 00-.897-1.38 3.723 3.723 0 00-1.38-.897c-.424-.164-1.058-.36-2.229-.413zm-6.382 13.467a4.002 4.002 0 004.364-6.53 4.003 4.003 0 10-4.364 6.53zM7.64 7.64a6.168 6.168 0 118.722 8.722A6.168 6.168 0 017.64 7.64zm11.897-.888a1.458 1.458 0 10-2-2.121 1.458 1.458 0 002 2.12z",
            fill: "#fff"
        })
    });
};

;// CONCATENATED MODULE: ./components/Footer/Footer.tsx








function Footer(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: classnames_default()("flex justify-center border-t border-white border-opacity-10", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center flex-1 px-10 py-8 max-w-9xl xl:flex-row xl:justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center xl:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-24 xl:mr-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "aria-label": "Back to main page",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: dawn_logo/* default */.Z,
                                        alt: "Dawn logo"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center flex-1 mt-8 space-y-8 text-sm leading-4 xl:text-base xl:flex-row xl:space-y-0 xl:space-x-14 xl:mt-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/legal/terms-of-service",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium tracking-widest text-white uppercase",
                                        children: "Terms"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/legal/privacy-policy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium tracking-widest text-white uppercase",
                                        children: "Privacy"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "https://www.notion.so/dawn-health/Dawn-Job-Board-c370eab65ee14522a716bc8fcbedd213",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "font-medium tracking-widest text-white uppercase",
                                        children: "Jobs"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:team@dawn.health",
                                    className: "font-medium tracking-widest text-white uppercase",
                                    children: "Contact"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#",
                                    className: "font-medium tracking-widest uppercase text-dawnDark-200",
                                    children: "\xa9 2023 Sleepedy, Inc"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center mt-6 space-x-12 text-white xl:mt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "https://www.facebook.com/dawnhealthapp",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Facebook",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFacebook/* default */.Z, {
                                    className: "w-6 h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "https://twitter.com/dawnhealthapp",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Twitter",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTwitter/* default */.Z, {
                                    className: "w-6 h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "https://www.instagram.com/dawnhealthapp/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": "Instagram",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconInstagram, {
                                    className: "w-6 h-6"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 1824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ Gradient; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/tailwindConfig.ts
var tailwindConfig = __webpack_require__(30049);
;// CONCATENATED MODULE: ./components/Gradient/Gradient.tsx


var tailwindColors = tailwindConfig/* theme */.r === null || tailwindConfig/* theme */.r === void 0 ? void 0 : tailwindConfig/* theme.colors */.r.colors;
var availableColors = {
    purple: tailwindColors["dawnPurple"]["500"],
    orange: tailwindColors["dawnOrange"]["500"]
};
function Gradient(param) {
    var color = param.color, _scale = param.scale, scale = _scale === void 0 ? 1 : _scale, _opacity = param.opacity, opacity = _opacity === void 0 ? 0.15 : _opacity, _right = param.right, right = _right === void 0 ? undefined : _right, _left = param.left, left = _left === void 0 ? undefined : _left, _top = param.top, top = _top === void 0 ? 0 : _top, _fixed = param.fixed, fixed = _fixed === void 0 ? false : _fixed;
    var width = 200;
    var height = 100;
    var selectedColor = availableColors[color];
    width = width * scale;
    height = height * scale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        style: {
            right: right,
            left: left,
            top: top
        },
        className: "".concat(fixed ? "fixed" : "absolute", "  z-0 overflow-hidden"),
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: opacity,
                filter: "url(#filter)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                    cx: "50%",
                    cy: "50%",
                    rx: "20%",
                    ry: "20%",
                    fill: selectedColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter",
                    x: "0",
                    y: "0",
                    width: width,
                    height: height,
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: Math.round(width * 0.07),
                            result: "effect1_foregroundBlur"
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Gradient/index.ts



/***/ }),

/***/ 34639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuestionnaireCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function QuestionnaireCTA(param) {
    var buttonText = param.buttonText, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/questionnaire",
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "flex items-center justify-center flex-1 max-w-md font-medium md:flex-none  px-10 py-4 text-sm tracking-widest text-center text-white uppercase rounded-full getStartedSleepIssues md:py-5 md:self-start bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 md:text-base"),
            children: buttonText || "Get Started"
        })
    });
};


/***/ }),

/***/ 12337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconFacebook; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function IconFacebook(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 24 24",
        className: "fill-current ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"
        })
    });
};


/***/ }),

/***/ 22971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconTwitter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function IconTwitter(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 24 24",
        className: "fill-current ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"
        })
    });
};


/***/ }),

/***/ 35540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ InsuranceLogos; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/aetna.png
/* harmony default export */ var aetna = ({"src":"/_next/static/media/aetna.c728b64a.png","height":64,"width":233,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEX///////////////////+Rd1MVAAAABXRSTlN1aVdDiOSz/mYAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAZSURBVHicBcEBAQAAAIIgrf5vDsAmadFN4AEbABx4X4GEAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/anthem.png
/* harmony default export */ var anthem = ({"src":"/_next/static/media/anthem.f1c31c08.png","height":56,"width":298,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEX///////////////////////+65XQCAAAABnRSTlMXKmtSWT+lBEPrAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVR4nGNgZGBkYGBkYmJgZWFmZmFlYgYAAPMAJbRcMxkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/bsbs.png
/* harmony default export */ var bsbs = ({"src":"/_next/static/media/bsbs.db1f9d2f.png","height":64,"width":301,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEX////////////LzM7OztDR0dP////BwcNUGzKIAAAACHRSTlNGXU+gj3UsdB1n5M4AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAaSURBVHicY2BmYWZiYGJgY2BmZWdgZGRkAgABkgAp1vwAawAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/uhc.png
/* harmony default export */ var uhc = ({"src":"/_next/static/media/uhc.da13deff.png","height":64,"width":323,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEX////////////////////////+/v4IluoxAAAAB3RSTlMrCztCGmp3VTcvyAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABpJREFUeJxjYGVgYmJmYmBgYGNgZmFkZGQEAAFAACCr+tkKAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/cigna.png
/* harmony default export */ var cigna = ({"src":"/_next/static/media/cigna.0f8dfdf5.png","height":80,"width":191,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEX///////////////////////+65XQCAAAABnRSTlNYIAsFbz69dI0mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHUlEQVR4nAXBAQEAAAzCoDl9/8oHMpIqGccAuRp9AmgALr6KfRUAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/aetna-mobile.png
/* harmony default export */ var aetna_mobile = ({"src":"/_next/static/media/aetna-mobile.d37ffa11.png","height":64,"width":197,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAD1BMVEX///////////////////+Rd1MVAAAABXRSTlMIARp+aKnDsaEAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAdSURBVHicFcKBDQAADMKgdvr/zYsEhBXSJBW58QEBuwAme3dCrQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/anthem-mobile.png
/* harmony default export */ var anthem_mobile = ({"src":"/_next/static/media/anthem-mobile.9f9fb173.png","height":64,"width":198,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAFVBMVEX///////////9MaXH///////////+tVghgAAAAB3RSTlMUB0EAUWmMgyxIpgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAB1JREFUeJxjYGRmZGZmZGBgYGJiYWJiYWNlgAJGAAKNACkjE+2oAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/bsbs-mobile.png
/* harmony default export */ var bsbs_mobile = ({"src":"/_next/static/media/bsbs-mobile.c5991e5d.png","height":64,"width":197,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEX////x8fH9/f3R09XIycv+/v7////+/v7////S09X1eseTAAAACnRSTlMZER8wsl1MZWK99Bzz8wAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAACBJREFUeJwFwYEBADAIwrACbur/D5uQxIDYqjc9HyRhcwQEAEeMHkACAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/uhc-mobile.png
/* harmony default export */ var uhc_mobile = ({"src":"/_next/static/media/uhc-mobile.d1ca94c3.png","height":64,"width":197,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAFVBMVEX///////////////9MaXH///////8nZ1FQAAAAB3RSTlMuDwkVAE2Nh7kRRQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAB9JREFUeJxjYGZkYmZmZGRiYGNgZQADZkZmJhYWFhYAApwANRho8a0AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/cigna-mobile.png
/* harmony default export */ var cigna_mobile = ({"src":"/_next/static/media/cigna-mobile.9c381aa1.png","height":64,"width":197,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEX///////////////////////+65XQCAAAABnRSTlMERCMRVHaQlj7AAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGUlEQVR4nGNgYGBkZgADJlZGRhYmMAssAAABUAAWcJxtUgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./components/page-sections/Insurance/InsuranceLogos.tsx












function InsuranceLogos() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex justify-center px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center justify-center md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-base text-center font-inter text-dawnDark-200",
                        children: "Accepted by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-6 gap-4 mt-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: aetna_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "aetna"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: anthem_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "anthem"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: cigna_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "cigna"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 col-start-2 cold-end-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: uhc_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "united healthcare"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: bsbs_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "blue cross blue shield"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-wrap items-center justify-center hidden gap-12 md:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-lg text-center font-inter text-dawnDark-200",
                        children: "Accepted by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: aetna,
                        height: 32,
                        width: 116,
                        alt: "aetna"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: anthem,
                        height: 28,
                        width: 148,
                        alt: "anthem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: cigna,
                        height: 40,
                        width: 95,
                        alt: "cigna"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: uhc,
                        height: 32,
                        width: 161,
                        alt: "united healthcare"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: bsbs,
                        height: 32,
                        width: 150,
                        alt: "blue cross blue shield"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Insurance/index.ts



/***/ }),

/***/ 39021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ TestimonialCarousel; },
  "H": function() { return /* reexport */ Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.esm.js
var embla_carousel_react_esm = __webpack_require__(25585);
// EXTERNAL MODULE: ./utils/tailwindConfig.ts
var tailwindConfig = __webpack_require__(30049);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/page-sections/Testimonials/Testimonials.tsx






var tailwindScreenBreakpoins = (tailwindConfig/* theme */.r === null || tailwindConfig/* theme */.r === void 0 ? void 0 : tailwindConfig/* theme.screens */.r.screens) || {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
};
function DotButton(param) {
    var isSelected = param.isSelected, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": "Toggle testimonial",
        onClick: onClick,
        className: "w-2 h-2 rounded-full ".concat(isSelected ? "bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500" : "bg-white bg-opacity-5")
    });
}
function TestimonialBox(param) {
    var text = param.text, source = param.source, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("relative flex-grow-0 flex-shrink-0 w-10/12 px-2 md:px-4 md:w-4/6 xl:w-1/3 md:pr-4 xl:pr-8", {
            "opacity-40 xl:opacity-100": !isActive
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-between h-full p-8 bg-white bg-opacity-5 rounded-2xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-lg leading-8 text-white md:text-2xl md:leading-10 font-inter",
                        children: [
                            "\u201C",
                            text,
                            "\u201D"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center mt-4 space-x-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-medium",
                            children: [
                                "- ",
                                source
                            ]
                        })
                    })
                })
            ]
        })
    });
}
function getActiveBreakpoints(breakpoints) {
    return Object.keys(breakpoints).filter(function(breakpoint) {
        return window.matchMedia("(min-width: ".concat(breakpoints[breakpoint], ")")).matches;
    });
}
function createEmblaCarouselConfig() {
    var activeBreakpoints = getActiveBreakpoints(tailwindScreenBreakpoins);
    var slidesToScroll = activeBreakpoints.includes("xl") ? 3 : 1;
    return {
        slidesToScroll: slidesToScroll,
        draggable: slidesToScroll <= 2,
        align: "center",
        startIndex: 1,
        loop: true
    };
}
function Testimonials(param) {
    var _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "py-16 bg-dawnDark-700 md:py-30",
        children: [
            showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "mx-8 text-3xl font-semibold text-center text-white md:text-5xl md:text-left",
                    children: [
                        "More Sleep.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "md:hidden"
                        }),
                        " Less Worries."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCarousel, {})
        ]
    });
}
function TestimonialCarousel() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,embla_carousel_react_esm/* default */.Z)(), 2), emblaCarouselRef = ref[0], emblaCarousel = ref[1];
    var ref1 = (0,react.useState)([]), scrollSnaps = ref1[0], setScrollSnaps = ref1[1];
    var ref2 = (0,react.useState)(1), selectedIndex = ref2[0], setSelectedIndex = ref2[1];
    var onSelect = (0,react.useCallback)(function() {
        if (!emblaCarousel) {
            return;
        }
        setSelectedIndex(emblaCarousel.selectedScrollSnap());
    }, [
        emblaCarousel,
        setSelectedIndex
    ]);
    var scrollTo = (0,react.useCallback)(function(index) {
        return emblaCarousel && emblaCarousel.scrollTo(index);
    }, [
        emblaCarousel
    ]);
    (0,react.useEffect)(function() {
        if (!emblaCarousel) {
            return;
        }
        setScrollSnaps(emblaCarousel.scrollSnapList());
        emblaCarousel.reInit(createEmblaCarouselConfig());
        emblaCarousel.on("select", onSelect);
        emblaCarousel.on("resize", function() {
            emblaCarousel.reInit(createEmblaCarouselConfig());
        });
    }, [
        emblaCarousel,
        setScrollSnaps,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: emblaCarouselRef,
                    className: "overflow-hidden max-w-7xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialBox, {
                                text: "The only approach that has tangibly improved my mental health in the long run. It is simple, long-lasting and sustainable.",
                                source: "Ilya V.",
                                isActive: selectedIndex === 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialBox, {
                                text: "I've spent a lot of money trying different things for my mental health. Dawn's CBT program was the only thing that made a difference.",
                                source: "Kevin L.",
                                isActive: selectedIndex === 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialBox, {
                                text: "I have been falling asleep within 10-15 mins. Dawn has been a huge improvement to my life and I\u2019m really glad I gave it a try.",
                                source: "Andrew K.",
                                isActive: selectedIndex === 2
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-4 xl:hidden pb-9 md:pb-28 xl:pb-52",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex space-x-2",
                    children: scrollSnaps.map(function(_, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DotButton, {
                            onClick: function() {
                                return scrollTo(index);
                            },
                            isSelected: selectedIndex === index
                        }, index);
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Testimonials/index.ts



/***/ }),

/***/ 16250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 6 modules
var Navbar = __webpack_require__(92595);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./public/images/index_page/get_personalized_insights.png
/* harmony default export */ var get_personalized_insights = ({"src":"/_next/static/media/get_personalized_insights.b5260c16.png","height":1344,"width":1498,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAS1BMVEVlZWVKSlZER04rLjQ0OUUeJCtTQ0clKjHe3t739/ccIig9OT8wNDgmKjEfJCsuNDpCPlZDRE0cIikZISgXIigXHyIbGyQyNjwqLTYBoGI8AAAAGHRSTlMBCUxo/a7+/QcP+4sguZj9/fd1eSxYOO/giMPOAAAACXBIWXMAACE4AAAhOAFFljFgAAAAOklEQVR4nAXBhwHAIAzAMDOTsLv5/9JKgEuphhulScx5YOYlHvlCNZS49oPTusueL1gXmV8D8+foiR86mQIUwrHGeQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/index_page/access_daily_lesson_plans.png
/* harmony default export */ var access_daily_lesson_plans = ({"src":"/_next/static/media/access_daily_lesson_plans.a5dbd21d.png","height":896,"width":998,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAM1BMVEXj4+MZHikuMjoaIi0dISkhJS5zc3xMaXH09PT09P+Dg4tLUVYUGR4RGiMOFCAgJC43PUnVRr/LAAAAD3RSTlMPmvdDgGI3AAgF+VgyHa5NOGaGAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAN0lEQVR4nBXLyRHAMAwDsbUjmWIupf9qM/7hAyQJyjxHxoLi/c5OUYyeHRvRs0dh7shrgdnLLv8tQwF40PgieAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/index_page/work_with_a_sleep_coach.png
/* harmony default export */ var work_with_a_sleep_coach = ({"src":"/_next/static/media/work_with_a_sleep_coach.a57d569a.png","height":1792,"width":1996,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAUVBMVEUWFhaJSiaGiIp1d3U6JBgkJyVqORgAAACpra2go6KrZjN9d3Y+Mix1b2man5+mZ0OUXj1hT0N7bmRFRkhISEnU2NOXk43r7+VvZl+Jg3vDxsD4xx9eAAAAFXRSTlME/sP4NzHJC+jnN7XPzrn+/v397u6p/m/LAAAACXBIWXMAACxLAAAsSwGlPZapAAAAO0lEQVR4nBXGSRKAIAwEwIGETVE2A+r/H0qlTw1YegZZIKQlspLmb100cZo6o+Yz5dXcl/f5BOD4YHbYSP8CH4v2PDsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/icons/checkmark.svg
/* harmony default export */ var checkmark = ({"src":"/_next/static/media/checkmark.4a59b793.svg","height":32,"width":24});
;// CONCATENATED MODULE: ./modules/main-page/HowItWorks.tsx







function HowItWorksSection(param) {
    var title = param.title, text = param.text, image = param.image, features = param.features, _isReversed = param.isReversed, isReversed = _isReversed === void 0 ? false : _isReversed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex justify-between w-full items-center flex-col-reverse", "".concat(isReversed ? "md:flex-row-reverse" : "md:flex-row")),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex flex-col justify-between mt-6 text-white md:mt-0", "".concat(isReversed ? "md:ml-8" : "md:mr-8")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-[501px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-2.5xl leading-8 font-semibold md:text-5xl md:leading-14",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-4 max-w-[395px] text-base md:text-xl md:leading-8 font-inter",
                                    children: text
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "pt-8 md:pt-20 font-inter",
                            children: features === null || features === void 0 ? void 0 : features.map(function(featureText) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "md:text-xl flex content-center",
                                    style: {
                                        listStyle: "none"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                alt: "checkmark",
                                                src: checkmark
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "pl-4 pt-2 md:pt-1",
                                            children: featureText
                                        })
                                    ]
                                }, featureText);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: image
                })
            ]
        })
    });
}
function HowItWorks() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-10 space-y-22 md:space-y-48",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksSection, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Support from ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "hidden md:inline-block"
                        }),
                        " the ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "md:hidden inline-block"
                        }),
                        " get-go."
                    ]
                }),
                text: "Build a strong, understanding relationship with your therapist from the very first call.",
                features: [
                    "Covered by most major insurances",
                    "Chat access to your therapist",
                    "Weekly 1-1 video therapy sessions", 
                ],
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: work_with_a_sleep_coach,
                    width: "499",
                    height: "448",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksSection, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Clarity through",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "hidden md:inline-block"
                        }),
                        " understanding"
                    ]
                }),
                text: "Learn about your sleep patterns that make sleeping easier.",
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: get_personalized_insights,
                    width: "499",
                    height: "448",
                    alt: ""
                }),
                features: [
                    "Live sleep performance insights",
                    "Weekly sleep progress reports",
                    "Compatible with many sleep trackers", 
                ],
                isReversed: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksSection, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "Confidence through education"
                }),
                text: "Unlearn misconceptions about sleep that deter your relationship with it.",
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: access_daily_lesson_plans,
                    width: "499",
                    height: "448",
                    alt: ""
                }),
                features: [
                    "Daily 5-7 minute sleep lessons",
                    "Discover FAQs per sleep topic"
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/page-sections/Insurance/index.ts + 11 modules
var Insurance = __webpack_require__(35540);
;// CONCATENATED MODULE: ./modules/main-page/OurScience.tsx

function OurScienceBox(param) {
    var icon = param.icon, title = param.title, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex-1 p-6 border border-transparent border-gradient-bl-orange-purple-white md:p-8 xl:p-10 rounded-xl",
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "mt-4 text-xl font-semibold md:mt-6 xl:text-2xl ",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-base leading-6 xl:text-xl xl:leading-8 font-inter",
                children: text
            })
        ]
    });
}
function OurScience() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-3xl mx-8 text-center md:text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-3xl font-semibold text-center md:text-5xl",
                            children: "Our Science"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-4 text-lg leading-6 text-center md:text-2xl md:leading-10",
                            children: "CBT-I focuses on exploring the connection between the way we think, the things we do, and how we sleep. This is called a multicomponent treatment, combining several approaches:"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-4 md:mt-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col mx-8 space-y-6 md:flex-row md:space-y-0 md:space-x-8 max-w-7xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OurScienceBox, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "w-6 h-6 md:w-8 md:h-8 xl:w-10 xl:h-10",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                        clipPath: "url(#clip0_66_3999)",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M1.3088 18.7149C1.8272 20.3134 3.4028 21.3334 5.084 21.3334H5.15C5.30424 22.0863 5.71363 22.7628 6.30899 23.2486C6.90435 23.7345 7.64917 23.9999 8.4176 24C8.966 24 9.4784 23.862 9.932 23.6244C10.1213 23.5206 10.2788 23.3672 10.3877 23.1808C10.4965 22.9943 10.5526 22.7818 10.55 22.5659V1.2309C10.5524 0.955962 10.4601 0.688577 10.2885 0.473728C10.117 0.258879 9.87665 0.109678 9.608 0.0512235C9.00597 -0.0657175 8.38219 0.0190622 7.8332 0.292439C6.9404 0.719667 6.4172 1.67373 6.4172 2.6662V2.7322C5.74905 2.59582 5.05516 2.66764 4.4291 2.93798C3.80305 3.20831 3.27495 3.66415 2.91604 4.24402C2.55714 4.82388 2.38468 5.49988 2.42194 6.18082C2.45919 6.86177 2.70437 7.51491 3.1244 8.05215C2.1837 8.19955 1.32665 8.67833 0.70789 9.4021C0.0891278 10.1259 -0.250601 11.047 -0.249999 11.9992C-0.249999 13.4129 0.483201 14.6526 1.5896 15.3738C1.0736 16.2991 0.904401 17.4692 1.3088 18.7149ZM20.3756 8.05215C20.7956 7.51491 21.0408 6.86177 21.0781 6.18082C21.1153 5.49988 20.9429 4.82388 20.584 4.24402C20.225 3.66415 19.6969 3.20831 19.0709 2.93798C18.4448 2.66764 17.7509 2.59582 17.0828 2.7322V2.6662C17.0828 1.67493 16.5584 0.719667 15.6656 0.292439C15.1171 0.0189809 14.4936 -0.0658085 13.892 0.0512235C13.6235 0.109884 13.3833 0.259141 13.2117 0.473944C13.0402 0.688747 12.9478 0.956019 12.95 1.2309V22.5647C12.95 23.0027 13.1804 23.4192 13.5692 23.6232C14.0228 23.862 14.534 24 15.0824 24C15.851 23.9998 16.596 23.7342 17.1913 23.2482C17.7867 22.7621 18.196 22.0853 18.35 21.3322H18.4172C20.0972 21.3322 21.674 20.3122 22.1924 18.7137C22.5968 17.468 22.4276 16.2979 21.9116 15.3726C22.4752 15.0085 22.9387 14.509 23.2598 13.9197C23.5809 13.3305 23.7494 12.6703 23.75 11.9992C23.7506 11.047 23.4109 10.1259 22.7921 9.4021C22.1733 8.67833 21.3163 8.19955 20.3756 8.05215Z",
                                            fill: "url(#paint0_linear_66_3999)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                id: "paint0_linear_66_3999",
                                                x1: "23.75",
                                                y1: "9.99447e-07",
                                                x2: "4.73346",
                                                y2: "27.4521",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        stopColor: "#FF8F5B"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "1",
                                                        stopColor: "#536DE2"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                id: "clip0_66_3999",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    width: "24",
                                                    height: "24",
                                                    fill: "white"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            title: "Cognitive Intervention",
                            text: "Learn strategies to challenge unhelpful thinking patterns."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OurScienceBox, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "w-6 h-6 md:w-8 md:h-8 xl:w-10 xl:h-10",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M13.3528 7.44C14.3999 7.44 15.2859 8.25333 15.2859 9.33333C15.2859 10.4133 14.3999 11.2533 13.3528 11.2533C12.3056 11.2533 11.4465 10.3733 11.4465 9.33333C11.4465 8.29333 12.2654 7.44 13.3528 7.44ZM13.3528 2.78448e-06C18.5615 2.78448e-06 22.75 4.18667 22.75 9.33333C22.75 13.0667 20.5618 16.2533 17.3802 17.7467V24H7.98291V20H6.64045C5.15031 20 3.95552 18.8133 3.95552 17.3333V13.3333H1.94183C1.37799 13.3333 1.0558 12.6667 1.37799 12.2533L3.95552 8.88C4.0738 6.48439 5.11572 4.22586 6.86528 2.5726C8.61484 0.919339 10.9379 -0.00184834 13.3528 2.78448e-06ZM17.3802 9.33333C17.3802 9.12 17.3802 9 17.2996 8.81333L18.4944 7.93333C18.5615 7.88 18.6152 7.69334 18.5615 7.56L17.4875 5.74667C17.4204 5.62667 17.2325 5.56 17.1117 5.62667L15.7826 6.18667C15.541 5.93333 15.2188 5.74667 14.91 5.62667L14.6952 4.25334C14.655 4.06667 14.5878 4 14.3999 4H12.2654C12.1311 4 12.0103 4.06667 12.0103 4.25334L11.8224 5.62667C11.5136 5.74667 11.1914 5.93333 10.9363 6.18667L9.55359 5.62667C9.43277 5.56 9.32537 5.62667 9.24483 5.74667L8.17086 7.56C8.10373 7.74667 8.10373 7.88 8.23798 7.93333L9.36565 8.81333C9.36565 9 9.32537 9.18667 9.32537 9.33333C9.32537 9.50667 9.36565 9.69333 9.36565 9.88L8.23798 10.7467C8.10373 10.8133 8.10373 10.9333 8.17086 11.0667L9.24483 12.9333C9.32537 13.0667 9.43277 13.0667 9.55359 13.0667L10.8826 12.4933C11.1914 12.7467 11.4465 12.88 11.8224 13L12.0103 14.44C12.0103 14.56 12.1311 14.6667 12.2654 14.6667H14.3999C14.5878 14.6667 14.655 14.56 14.6952 14.44L14.91 13C15.2188 12.88 15.541 12.7467 15.7826 12.5067L17.1117 13.0667C17.2325 13.0667 17.4204 13.0667 17.4875 12.9333L18.5615 11.0667C18.6152 10.9333 18.5615 10.8133 18.4944 10.7467L17.3802 9.88V9.33333Z",
                                        fill: "url(#paint0_linear_66_4005)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                            id: "paint0_linear_66_4005",
                                            x1: "22.75",
                                            y1: "9.99447e-07",
                                            x2: "3.0909",
                                            y2: "25.4235",
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                    stopColor: "#FF8F5B"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                    offset: "1",
                                                    stopColor: "#536DE2"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            title: "Behavioral Intervention",
                            text: "Get help identifying and changing habits that stand in the way of a great night of sleep."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OurScienceBox, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "w-6 h-6 md:w-8 md:h-8 xl:w-10 xl:h-10",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                        clipPath: "url(#clip0_66_4011)",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M12 2.67444C10.5225 1.40394 8.3805 1.21494 6.4305 1.40994C4.1595 1.63944 1.8675 2.41794 0.4395 3.06744C0.308474 3.12703 0.197363 3.22307 0.119432 3.34409C0.0415 3.46511 3.98571e-05 3.606 0 3.74994L0 20.2499C3.4743e-05 20.3754 0.0315557 20.4989 0.0916756 20.6091C0.151796 20.7192 0.238593 20.8125 0.344116 20.8804C0.44964 20.9483 0.570517 20.9887 0.695675 20.9978C0.820833 21.0069 0.946271 20.9844 1.0605 20.9324C2.3835 20.3324 4.515 19.6109 6.5805 19.4024C8.694 19.1894 10.4655 19.5329 11.415 20.7179C11.4853 20.8055 11.5743 20.8762 11.6756 20.9248C11.7768 20.9734 11.8877 20.9986 12 20.9986C12.1123 20.9986 12.2232 20.9734 12.3244 20.9248C12.4257 20.8762 12.5147 20.8055 12.585 20.7179C13.5345 19.5329 15.306 19.1894 17.418 19.4024C19.485 19.6109 21.618 20.3324 22.9395 20.9324C23.0537 20.9844 23.1792 21.0069 23.3043 20.9978C23.4295 20.9887 23.5504 20.9483 23.6559 20.8804C23.7614 20.8125 23.8482 20.7192 23.9083 20.6091C23.9684 20.4989 24 20.3754 24 20.2499V3.74994C24 3.606 23.9585 3.46511 23.8806 3.34409C23.8026 3.22307 23.6915 3.12703 23.5605 3.06744C22.1325 2.41794 19.8405 1.63944 17.5695 1.40994C15.6195 1.21344 13.4775 1.40394 12 2.67444Z",
                                            fill: "url(#paint0_linear_66_4011)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                id: "paint0_linear_66_4011",
                                                x1: "24",
                                                y1: "1.34375",
                                                x2: "9.71994",
                                                y2: "26.5142",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        stopColor: "#FF8F5B"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "1",
                                                        stopColor: "#536DE2"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                id: "clip0_66_4011",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    width: "24",
                                                    height: "24",
                                                    fill: "white"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            title: "Educational Intervention",
                            text: "Understand how the connection between thoughts, feelings, behaviors, and sleep is central to CBT-I."
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/images/index_page/woman_stretching.png
/* harmony default export */ var woman_stretching = ({"src":"/_next/static/media/woman_stretching.d6228237.png","height":768,"width":852,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAb1BMVEVMaXHTyPajbX/108/eparCwv2eo+744//EeXH/4uTfhH/8yMXs197asey0e4m3iJ3YscHUwPbDor3AyP/wxOPooqXlrb/buuj57fuAYpW3svHKsNz3zez62t3h0/u2krOTY4C9r+X/zdeEgc+KfsYU4E6BAAAAGHRSTlMA/g7B8/T++nY5OPPDOP79+bn+o+az7Z9YdsTvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVR4nBXBBxKAIBAEsAWBAwt2pCm2/7/RMQHAtcbPtEJUBujI93ZvaoyeyjncKyQ7Upiyg3ziFVJeMCsVX0bbB0/BA0zVGDntAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./components/QuestionnaireCTA/QuestionnaireCTA.tsx
var QuestionnaireCTA = __webpack_require__(34639);
;// CONCATENATED MODULE: ./modules/main-page/SleepIssues.tsx






function SleepIssueOption(param) {
    var onClick = param.onClick, isActive = param.isActive, text = param.text, icon = param.icon, iconActive = param.iconActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        onClick: onClick,
        className: "flex h-18 md:h-auto items-center justify-between rounded-full px-8 py-4 cursor-pointer ".concat(isActive ? "border md:border-1.5 border-gradient-bl-orange-purple-white border-transparent font-medium" : "border border-dawnDark-200"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-base md:text-xl",
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-3",
                children: isActive ? iconActive : icon
            })
        ]
    });
}
function SleepIssues() {
    var toggleIssue = function toggleIssue(issueId) {
        if (activeIssues.includes(issueId)) {
            setActiveIssues(activeIssues.filter(function(id) {
                return id !== issueId;
            }));
        } else {
            setActiveIssues(_toConsumableArray(activeIssues).concat([
                issueId
            ]));
        }
    };
    var ref = (0,react.useState)([]), activeIssues = ref[0], setActiveIssues = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center flex-1 xl:items-start xl:flex-row xl:space-x-32 max-w-7xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative hidden w-full h-108 xl:h-full xl:-ml-72 md:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: woman_stretching,
                        alt: "Woman stretching in bed",
                        layout: "fill",
                        objectFit: "scale-down"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full h-108 md:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: woman_stretching,
                        alt: "Woman stretching in bed",
                        layout: "fill",
                        objectFit: "cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-8 mt-10 xl:mb-32 xl:mx-0 xl:pr-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-3xl font-semibold leading-8 text-center md:text-5xl md:leading-tight xl:text-left whitespace-nowrap",
                            children: "What can we help with?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col mt-8 space-y-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SleepIssueOption, {
                                    isActive: activeIssues.includes("fall-asleep"),
                                    onClick: function() {
                                        return toggleIssue("fall-asleep");
                                    },
                                    text: "Fall asleep more easily",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M30.0001 12.6666C29.1023 12.4844 28.1994 12.3226 27.2929 12.18L26.6667 4.66659C26.6667 4.66659 22.6667 3.33325 16.0001 3.33325C9.33342 3.33325 5.33341 4.66659 5.33341 4.66659L4.70729 12.18C3.8008 12.3226 2.8979 12.4844 2.00008 12.6666L0.666748 28.6666H1.67021L2.9339 13.5023C7.22787 12.687 11.6385 12.3333 16.0001 12.3333C20.3616 12.3333 24.7723 12.687 29.0663 13.5023L30.3299 28.6666H31.3334L30.0001 12.6666ZM6.27268 5.43696L5.72338 12.0285C7.43166 11.7875 9.15066 11.6135 10.8705 11.4998C10.9729 10.7925 11.2809 10.0695 11.7156 9.48492C12.2497 8.76665 13.0477 8.16661 14.0001 8.16661H18.0001C18.9526 8.16661 19.7506 8.76665 20.2847 9.48492C20.7194 10.0695 21.0274 10.7925 21.1297 11.4998C22.8496 11.6135 24.5685 11.7875 26.2768 12.0285L25.7275 5.43696L25.6852 5.42587C25.2288 5.30681 24.545 5.14569 23.6545 4.98379C21.8734 4.65995 19.2669 4.33325 16.0001 4.33325C12.7333 4.33325 10.1267 4.65995 8.34563 4.98379C7.45516 5.14569 6.77138 5.30681 6.315 5.42587L6.27268 5.43696ZM20.103 11.439C20.002 10.9739 19.7853 10.4892 19.4822 10.0816C19.0497 9.4999 18.5143 9.16661 18.0001 9.16661H14.0001C13.4859 9.16661 12.9506 9.4999 12.518 10.0816C12.215 10.4892 11.9982 10.9739 11.8972 11.439C13.2672 11.3674 14.6365 11.3333 16.0001 11.3333C17.3637 11.3333 18.733 11.3674 20.103 11.439ZM29.6668 22.8333H2.33346V23.8333H29.6668V22.8333Z",
                                            fill: "#19212C"
                                        })
                                    }),
                                    iconActive: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M30.0001 12.6666C29.1023 12.4844 28.1994 12.3226 27.2929 12.18L26.6667 4.66659C26.6667 4.66659 22.6667 3.33325 16.0001 3.33325C9.33342 3.33325 5.33341 4.66659 5.33341 4.66659L4.70729 12.18C3.8008 12.3226 2.8979 12.4844 2.00008 12.6666L0.666748 28.6666H2.17195L2.55389 24.0833H29.4463L29.8282 28.6666H31.3334L30.0001 12.6666ZM6.74135 5.83378L6.23092 11.9589C7.68749 11.7649 9.15114 11.619 10.6158 11.5171C10.7167 10.747 11.0477 9.96405 11.5149 9.33575C12.0744 8.58334 12.9381 7.91661 14.0001 7.91661H18.0001C19.0621 7.91661 19.9258 8.58334 20.4853 9.33575C20.9525 9.96405 21.2835 10.747 21.3845 11.5171C22.8491 11.619 24.3127 11.7649 25.7692 11.9589L25.2588 5.83378C24.8317 5.729 24.2636 5.60273 23.5651 5.47572C21.8101 5.15663 19.2336 4.83325 16.0001 4.83325C12.7665 4.83325 10.1901 5.15663 8.43508 5.47572C7.73652 5.60273 7.16847 5.729 6.74135 5.83378ZM19.8435 11.4259C19.7451 11.0188 19.5511 10.5932 19.2816 10.2308C18.8744 9.68321 18.4048 9.41661 18.0001 9.41661H14.0001C13.5955 9.41661 13.1258 9.68321 12.7186 10.2308C12.4492 10.5932 12.2551 11.0188 12.1567 11.4259C13.4401 11.3632 14.7226 11.3333 16.0001 11.3333C17.2776 11.3333 18.5601 11.3632 19.8435 11.4259ZM2.67889 22.5833L3.40051 13.9239C7.54161 13.1647 11.7915 12.8333 16.0001 12.8333C20.2086 12.8333 24.4586 13.1647 28.5997 13.9239L29.3213 22.5833H2.67889Z",
                                                fill: "url(#paint0_linear)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear",
                                                    x1: "31.3334",
                                                    y1: "3.33325",
                                                    x2: "12.8477",
                                                    y2: "35.6371",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#FF8F5B"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#536DE2"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SleepIssueOption, {
                                    isActive: activeIssues.includes("staying-asleep"),
                                    onClick: function() {
                                        return toggleIssue("staying-asleep");
                                    },
                                    text: "Sleep through the night",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M24.6665 1.16675H29.4665L25.0665 7.03341L24.4665 7.83341H25.4665H31.3332V6.83341H26.4665L30.8665 0.966748L31.4665 0.166748H30.4665H24.6665V1.16675ZM21 6.5001H15V5.5001H22H23L22.4 6.3001L17 13.5001H23V14.5001H16H15L15.6 13.7001L21 6.5001ZM23.3333 23.7334C22.9222 23.887 22.508 24.0158 22.0924 24.1206C16.3749 25.5623 10.3842 22.4602 8.33325 16.8668C7.4892 14.6722 7.35757 12.2402 7.93837 9.97161C8.04568 9.55246 8.17731 9.1389 8.33325 8.73344C7.90598 8.88838 7.49359 9.06582 7.09689 9.26392C1.86107 11.8786 -0.640442 18.094 1.46659 23.7334C3.73325 29.8001 10.4666 32.8668 16.5333 30.6001C18.0666 30.0001 19.4666 29.0668 20.6666 27.9334C21.5482 27.0518 22.2499 26.0623 22.7981 24.9647C22.9961 24.5684 23.1741 24.1579 23.3333 23.7334ZM21.4879 25.2737C21.063 25.9776 20.56 26.6242 19.9695 27.2163C18.8551 28.2666 17.5682 29.1201 16.176 29.6661C10.6281 31.7345 4.47562 28.9298 2.40334 23.3834C0.580426 18.5045 2.52754 13.1651 6.7828 10.579C6.38111 12.7928 6.58587 15.1051 7.39707 17.2184C9.52686 23.0158 15.548 26.3439 21.4879 25.2737Z",
                                            fill: "#19212C"
                                        })
                                    }),
                                    iconActive: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                clipPath: "url(#clip0)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M24.6665 1.41675H28.9665L24.8665 6.88341L23.9665 8.08341H25.4665H31.3332V6.58341H26.9665L31.0665 1.11675L31.9665 -0.083252H30.4665H24.6665V1.41675ZM20.5 6.7501H15V5.2501H22H23.5L22.6 6.4501L17.5 13.2501H23V14.7501H16H14.5L15.4 13.5501L20.5 6.7501ZM23.3333 23.7334C22.7185 23.9631 22.097 24.1373 21.474 24.2588C15.9486 25.3357 10.3103 22.2588 8.33325 16.8668C7.5655 14.8706 7.38719 12.678 7.79832 10.5906C7.92269 9.95912 8.101 9.33729 8.33325 8.73344C7.68245 8.96944 7.06617 9.25762 6.4873 9.59154C1.67001 12.3704 -0.556925 18.3176 1.46659 23.7334C3.73325 29.8001 10.4666 32.8668 16.5333 30.6001C18.0666 30.0001 19.4666 29.0668 20.6666 27.9334C21.3826 27.2174 21.9799 26.4302 22.4727 25.5718C22.8059 24.9916 23.0913 24.3788 23.3333 23.7334ZM19.621 26.8577C19.9176 26.5598 20.1912 26.2472 20.4431 25.9193C14.6522 26.4456 9.00929 23.0521 6.929 17.3942C6.22401 15.5561 5.95976 13.5742 6.13626 11.6283C2.72306 14.2593 1.2687 18.918 2.87171 23.2084C4.8468 28.4947 10.7088 31.1683 15.9974 29.199C17.319 28.6801 18.5493 27.8664 19.621 26.8577Z",
                                                    fill: "url(#paint0_linear)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                        id: "paint0_linear",
                                                        x1: "31.9665",
                                                        y1: "-0.0832506",
                                                        x2: "7.01192",
                                                        y2: "35.7308",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                stopColor: "#FF8F5B"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                offset: "1",
                                                                stopColor: "#536DE2"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                            width: "32",
                                                            height: "32",
                                                            fill: "white"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SleepIssueOption, {
                                    isActive: activeIssues.includes("without-pills"),
                                    onClick: function() {
                                        return toggleIssue("without-pills");
                                    },
                                    text: "Sleep without taking pills",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                clipPath: "url(#clip0)",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M26.8424 5.15786C29.718 8.03343 29.718 12.6532 26.8424 15.5288L15.5287 26.8425C12.6532 29.718 8.03339 29.718 5.15782 26.8425C2.28225 23.9669 2.28225 19.3471 5.15782 16.4716L16.4715 5.15786C19.3471 2.28229 23.9669 2.28229 26.8424 5.15786Z",
                                                        stroke: "#19212C",
                                                        strokeMiterlimit: "10"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M10.8147 10.8147L21.1856 21.1856",
                                                        stroke: "#19212C",
                                                        strokeMiterlimit: "10"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                    id: "clip0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "32",
                                                        height: "32",
                                                        fill: "white"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    iconActive: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                clipPath: "url(#clip0)",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M26.8424 5.15786C29.718 8.03343 29.718 12.6532 26.8424 15.5288L15.5287 26.8425C12.6532 29.718 8.03339 29.718 5.15782 26.8425C2.28225 23.9669 2.28225 19.3471 5.15782 16.4716L16.4715 5.15786C19.3471 2.28229 23.9669 2.28229 26.8424 5.15786Z",
                                                        stroke: "url(#paint0_linear)",
                                                        strokeWidth: "1.5",
                                                        strokeMiterlimit: "10"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M10.8147 10.8147L21.1856 21.1856",
                                                        stroke: "url(#paint1_linear)",
                                                        strokeWidth: "1.5",
                                                        strokeMiterlimit: "10"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                        id: "paint0_linear",
                                                        x1: "32.0279",
                                                        y1: "10.3433",
                                                        x2: "3.01744",
                                                        y2: "5.03027",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                stopColor: "#FF8F5B"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                offset: "1",
                                                                stopColor: "#536DE2"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                        id: "paint1_linear",
                                                        x1: "21.1856",
                                                        y1: "21.1856",
                                                        x2: "19.9349",
                                                        y2: "22.3235",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                stopColor: "#FF8F5B"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                offset: "1",
                                                                stopColor: "#536DE2"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                            width: "32",
                                                            height: "32",
                                                            fill: "white"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionnaireCTA/* default */.Z, {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/page-sections/Testimonials/index.ts + 1 modules
var Testimonials = __webpack_require__(39021);
;// CONCATENATED MODULE: ./modules/main-page/FrequentlyAskedQuestions.tsx



var frequentlyAskedQuestionsAndAnwesData = [
    {
        question: "How does sleep therapy work?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Dawn pairs you with a personal sleep therapist. Your therapist will answer any questions you have and personalize the program for you based on your needs. Our therapists are licensed professionals that are trained in CBT-I and have helped patients adhere to the program and improve their sleep."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Having a therapist also ensures accountability which is the most important part of a behavioral change program. Our therapists will motivate, hold you accountable and ensure that you have success and meet your goals."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "The cost of weekly therapy visits depends on insurance. Our private pay rate is $125 for a 60 minute session."
                })
            ]
        })
    },
    {
        question: "What kind of time commitment does Dawn require?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Most of our patients use Dawn 5 minutes a day and stick to the program for 3 months."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Dawn requires that you are able to keep a consistent wake-up time for at least 4 weeks. If you are planning any international travel, we recommend trying Dawn after you are over jet lag."
                })
            ]
        })
    },
    {
        question: "How much does Dawn cost?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Dawn is covered by most private insurance in select states. Copays generally range from $0-$30 per session. We can give you a cost estimate during the enrollment call. "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Without coverage, Dawn costs $75 per session."
                })
            ]
        })
    },
    {
        question: "Can I use Dawn even if I already have a therapist?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes! Please tell your therapist that you plan to try a CBT-I program. Many of them are extremely supportive of behavioral change programs."
            })
        })
    },
    {
        question: "Is Dawn reimbursable through health insurance?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Yes! Dawn is in-network with Optum, Aetna, UHC, Cigna, Oscar and Blue Cross Blue Shield in certain states."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Dawn\u2019s programs are offered at no cost through many insurance plans, but insurance is complex and specific employers can opt in or out of providing certain benefits. If your insurance information is not accepted when you attempt to enroll, it likely means that your insurance is not participating. We apologize for any inconvenience or frustration that this may cause you. "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "We provide superbills that can be submitted for out of network reimbursement among certain plans."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "If you are a member of a health insurance plan that does not cover Dawn\u2019s programs and would like to see Dawn as a covered benefit in the future, we encourage you to reach out to your insurance company or employer\u2019s member support team (via the phone number on your insurance card) and share your interest in the program."
                })
            ]
        })
    }, 
];
var FrequentlyAskedQuestionAndAnswer = function(param) {
    var index = param.index, isExpanded = param.isExpanded, setExpandedIndex = param.setExpandedIndex, question = param.question, answer = param.answer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        onClick: function() {
            return setExpandedIndex(isExpanded ? -1 : index);
        },
        className: "py-6 text-left text-white border-b border-white md:py-8 border-opacity-10 last:border-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex items-center justify-between w-full space-x-4", {
                    "mb-4": isExpanded
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-xl font-medium leading-6 text-left font-inter md:text-2xl",
                        children: question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "17",
                            height: "10",
                            viewBox: "0 0 17 10",
                            fill: "none",
                            children: [
                                isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M16.5 9L8.5 0.999998L0.5 9",
                                    stroke: "url(#paint0_linear)",
                                    strokeMiterlimit: "10"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M0.5 1L8.5 9L16.5 1",
                                    stroke: "url(#paint0_linear)",
                                    strokeMiterlimit: "10"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                        id: "paint0_linear",
                                        x1: "0.499999",
                                        y1: "9",
                                        x2: "4.68789",
                                        y2: "-3.09122",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                stopColor: "#FF8F5B"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                offset: "1",
                                                stopColor: "#536DE2"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mr-6 overflow-hidden text-base md:text-xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col space-y-8 font-inter",
                    children: answer
                })
            })
        ]
    });
};
function FrequentlyAskedQuestions() {
    var ref = (0,react.useState)(-1), expandedIndex = ref[0], setExpandedIndex = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex justify-center py-12 mx-8 md:py-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex-1 max-w-3.5xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-3xl font-semibold text-left md:text-center text-white md:text-5xl",
                    children: "Frequently Asked Questions"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col mt-14",
                    children: frequentlyAskedQuestionsAndAnwesData.map(function(data, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestionAndAnswer, {
                            index: index,
                            isExpanded: index === expandedIndex,
                            setExpandedIndex: setExpandedIndex,
                            question: data.question,
                            answer: data.answer
                        }, index);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(15445);
;// CONCATENATED MODULE: ./components/page-sections/SleepMetrics/SleepMetrics.tsx


function Metric(param) {
    var metricText = param.metricText, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center w-[250px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center text-[4.5rem] font-bold text-transparent bg-clip-text bg-gradient-to-bl from-dawnOrange-500 to-dawnPurple-500",
                children: metricText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-center h-[48px] w-[250px] md:text-xl",
                children: subtitle
            })
        ]
    });
}
function SleepMetrics() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()("flex flex-col items-center px-8 pt-22 pb-6 md:pt-30 md:pb-6 bg-white"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-12 flex-row flex-wrap items-center justify-center ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                        metricText: "75%",
                        subtitle: "less time needed to fall asleep"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                        metricText: "80%",
                        subtitle: "less time awake in the middle of the night"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                        metricText: "60%",
                        subtitle: "decrease in insomnia symptoms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Metric, {
                        metricText: "90 min",
                        subtitle: "increase in total sleep time"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "italic md:text-base text-center text-dawnDark-400 mt-24",
                children: "Based on users who followed the program for 1 month or more"
            })
        ]
    });
}

// EXTERNAL MODULE: ./lib/experiments.ts + 1 modules
var experiments = __webpack_require__(8996);
;// CONCATENATED MODULE: ./components/page-sections/Heros/HomeHero.tsx



function HomeHero() {
    var ref, ref1;
    var heroVariant = (0,experiments/* useVariant */.c1)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "px-6 text-white md:px-12 pt-26 md:pt-44",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto max-w-s md:max-w-3xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: "text-5xl md:text-5.5xl leading-14 text-center md:leading-18 font-bold",
                    children: [
                        (heroVariant === null || heroVariant === void 0 ? void 0 : heroVariant.name) || "Say Goodbye to Tossing and Turning",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500",
                            children: (heroVariant === null || heroVariant === void 0 ? void 0 : (ref = heroVariant.metadata) === null || ref === void 0 ? void 0 : ref.gradientText) || "With Dawn."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-lg leading-6 text-center md:text-2xl md:leading-10",
                            children: (heroVariant === null || heroVariant === void 0 ? void 0 : (ref1 = heroVariant.metadata) === null || ref1 === void 0 ? void 0 : ref1.subtitle) || "Getting good sleep is more than taking sleep medication. We offer everything you need to quit sleep medications for good."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center mt-4 md:mt-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionnaireCTA/* default */.Z, {})
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/index.tsx













function Index() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Overcome Insomnia With CBT-I & Sleep Coaching \u2014 Sleep App | Dawn Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Struggling with insomnia? Ditch the pills and cure your insomnia for good with Dawn's proven online CBT-I app. Let our sleep experts get you back to sleep."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: "lypvevgg0c2g46jzbubi2frb5kd96o"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-x-hidden bg-dawnDark-700",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "purple",
                                scale: 7,
                                opacity: 0.25,
                                left: "-50rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "orange",
                                scale: 8,
                                opacity: 0.15,
                                left: "-60rem",
                                top: "10rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "purple",
                                scale: 7,
                                opacity: 0.25,
                                right: "-30rem",
                                top: "-20rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "orange",
                                scale: 7,
                                opacity: 0.1,
                                right: "-40rem",
                                top: "-2rem"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeHero, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-28 md:pt-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Insurance/* InsuranceLogos */.w, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-12 md:pt-18",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SleepMetrics, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "flex justify-center pt-26 pb-28 bg-dawnDark-700 md:py-48",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorks, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "bg-white pt-26 pb-26 xl:pb-0 xl:pt-48",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurScience, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-26 xl:mt-48",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SleepIssues, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* Testimonials */.H, {
                        showTitle: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 41125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var _object_spread = (__webpack_require__(50337)/* ["default"] */ .Z);
var _to_consumable_array = (__webpack_require__(53929)/* ["default"] */ .Z);
var defaultTheme = __webpack_require__(75874);
module.exports = {
    purge: [
        "./pages/**/*.{js,ts,jsx,tsx}",
        "./modules/**/*.{js,ts,jsx,tsx}",
        "./lib/**/*.{js,ts,jsx,tsx}",
        "./components/**/*.{js,ts,jsx,tsx}", 
    ],
    mode: "jit",
    darkMode: false,
    theme: {
        linearBorderGradients: function(theme) {
            return {
                colors: _object_spread({
                    "orange-purple": [
                        theme("colors.dawnOrange.500"),
                        theme("colors.dawnPurple.500")
                    ]
                }, theme("colors")),
                background: _object_spread({
                    white: theme("colors.white")
                }, theme("colors"))
            };
        },
        colors: {
            dawnDark: {
                100: "#EFF2F6",
                150: "#E5E5E5",
                200: "#BBBDC5",
                300: "#858992",
                400: "#4F555F",
                500: "#19212C",
                550: "#232832",
                600: "#151B25",
                700: "#11161E",
                800: "#0D1117",
                900: "#090C10"
            },
            dawnOrange: {
                100: "#FFEEE5",
                200: "#FFD7C4",
                300: "#FFBFA1",
                400: "#FFA77E",
                500: "#FF8F5B",
                600: "#C56E45",
                700: "#8C4C2E",
                800: "#532A17",
                900: "#1A0800"
            },
            dawnPurple: {
                100: "#E9EDFB",
                200: "#C5CDF4",
                300: "#9FADEE",
                400: "#798DE8",
                500: "#536DE2",
                600: "#4055AF",
                700: "#2C3B7C",
                800: "#182149",
                900: "#040716"
            },
            dawnRed: {
                500: "#E24328"
            },
            dawnGreen: {
                500: "#E24328"
            },
            white: "#fff",
            black: "#000",
            transparent: "transparent"
        },
        extend: {
            spacing: {
                1.5: "0.375rem",
                13: "3.25rem",
                18: "4.5rem",
                22: "5.5rem",
                26: "6.5rem",
                30: "7.5rem",
                34: "8.5rem",
                38: "9.5rem",
                62: "15.5rem",
                100: "25rem",
                108: "27rem",
                500: "31.25rem"
            },
            maxWidth: {
                "1.5xl": "38rem",
                "3.5xl": "52rem",
                "8xl": "88rem",
                "9xl": "96rem"
            },
            fontFamily: {
                sans: [
                    "Epilogue"
                ].concat(_to_consumable_array(defaultTheme.fontFamily.sans)),
                inter: [
                    "Inter"
                ].concat(_to_consumable_array(defaultTheme.fontFamily.sans))
            },
            fontSize: {
                "2.5xl": "1.75rem",
                "3.5xl": "2rem",
                "5.5xl": "3.5rem",
                "6.25xl": "4rem"
            },
            lineHeight: {
                12: "3rem",
                14: "3.5rem",
                18: "4.5rem"
            },
            zIndex: {
                "-10": "-10",
                "-05": "-05"
            },
            borderWidth: {
                1.5: "1.5px"
            },
            borderRadius: {
                dawnDefault: "2.5rem"
            },
            inset: {
                "60%": "60%"
            },
            backdropBlur: {
                "1.5xl": "2.25rem"
            },
            opacity: {
                6: "0.06"
            },
            maxHeight: {
                1000: "100rem"
            },
            typography: function(theme) {
                return {
                    DEFAULT: {
                        css: {
                            a: {
                                "word-break": "break-word",
                                "overflow-wrap": "break-word",
                                fontWeight: "normal",
                                "text-decoration": "none",
                                color: theme("colors.dawnPurple.500"),
                                "&:hover": {
                                    color: theme("colors.dawnPurple.600")
                                }
                            }
                        }
                    }
                };
            }
        }
    },
    plugins: [
        __webpack_require__(50130),
        __webpack_require__(54863),
        __webpack_require__(34270),
        __webpack_require__(2112), 
    ]
};


/***/ }),

/***/ 30049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ theme; }
/* harmony export */ });
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86926);
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tailwind_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41125);
/* harmony import */ var _tailwind_config_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tailwind_config_js__WEBPACK_IMPORTED_MODULE_1__);


var theme = tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default()((_tailwind_config_js__WEBPACK_IMPORTED_MODULE_1___default())).theme;


/***/ }),

/***/ 6512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Le; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19946);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61363);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64103);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14157);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15466);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73781);
var J=(l=>(l[l.Open=0]="Open",l[l.Closed=1]="Closed",l))(J||{}),Q=(t=>(t[t.ToggleDisclosure=0]="ToggleDisclosure",t[t.CloseDisclosure=1]="CloseDisclosure",t[t.SetButtonId=2]="SetButtonId",t[t.SetPanelId=3]="SetPanelId",t[t.LinkPanel=4]="LinkPanel",t[t.UnlinkPanel=5]="UnlinkPanel",t))(Q||{});let V={[0]:e=>({...e,disclosureState:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(e.disclosureState,{[0]:1,[1]:0})}),[1]:e=>e.disclosureState===1?e:{...e,disclosureState:1},[4](e){return e.linkedPanel===!0?e:{...e,linkedPanel:!0}},[5](e){return e.linkedPanel===!1?e:{...e,linkedPanel:!1}},[2](e,n){return e.buttonId===n.buttonId?e:{...e,buttonId:n.buttonId}},[3](e,n){return e.panelId===n.panelId?e:{...e,panelId:n.panelId}}},B=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);B.displayName="DisclosureContext";function v(e){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(B);if(n===null){let l=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(l,v),l}return n}let h=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);h.displayName="DisclosureAPIContext";function K(e){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h);if(n===null){let l=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(l,K),l}return n}let H=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);H.displayName="DisclosurePanelContext";function X(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(H)}function Y(e,n){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(n.type,V,e,n)}let Z=react__WEBPACK_IMPORTED_MODULE_0__.Fragment,ee=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let{defaultOpen:y=!1,...u}=n,T=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),t=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(l,(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .optionalRef */ .h)(a=>{T.current=a},n.as===void 0||n.as===react__WEBPACK_IMPORTED_MODULE_0__.Fragment)),o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),s=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Y,{disclosureState:y?0:1,linkedPanel:!1,buttonRef:f,panelRef:o,buttonId:null,panelId:null}),[{disclosureState:i,buttonId:p},D]=s,d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(a=>{D({type:1});let r=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .getOwnerDocument */ .r)(T);if(!r||!p)return;let c=(()=>a?a instanceof HTMLElement?a:a.current instanceof HTMLElement?a.current:r.getElementById(p):r.getElementById(p))();c==null||c.focus()}),P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({close:d}),[d]),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:i===0,close:d}),[i,d]),S={ref:t};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(B.Provider,{value:s},react__WEBPACK_IMPORTED_MODULE_0__.createElement(h.Provider,{value:P},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(i,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Closed */ .ZM.Closed})},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:S,theirProps:u,slot:A,defaultTag:Z,name:"Disclosure"}))))}),te="button",ne=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let y=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__/* .useId */ .M)(),{id:u=`headlessui-disclosure-button-${y}`,...T}=n,[t,o]=v("Disclosure.Button"),f=X(),s=f===null?!1:f===t.panelId,i=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),p=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(i,l,s?null:t.buttonRef);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!s)return o({type:2,buttonId:u}),()=>{o({type:2,buttonId:null})}},[u,o,s]);let D=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{var c;if(s){if(t.disclosureState===1)return;switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),o({type:0}),(c=t.buttonRef.current)==null||c.focus();break}}else switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),o({type:0});break}}),d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:r.preventDefault();break}}),P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{var c;(0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__/* .isDisabledReactIssue7711 */ .P)(r.currentTarget)||n.disabled||(s?(o({type:0}),(c=t.buttonRef.current)==null||c.focus()):o({type:0}))}),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.disclosureState===0}),[t]),S=(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__/* .useResolveButtonType */ .f)(n,i),a=s?{ref:p,type:S,onKeyDown:D,onClick:P}:{ref:p,id:u,type:S,"aria-expanded":n.disabled?void 0:t.disclosureState===0,"aria-controls":t.linkedPanel?t.panelId:void 0,onKeyDown:D,onKeyUp:d,onClick:P};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:a,theirProps:T,slot:A,defaultTag:te,name:"Disclosure.Button"})}),le="div",re=_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.Static */ .AN.Static,oe=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let y=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__/* .useId */ .M)(),{id:u=`headlessui-disclosure-panel-${y}`,...T}=n,[t,o]=v("Disclosure.Panel"),{close:f}=K("Disclosure.Panel"),s=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(l,t.panelRef,P=>{o({type:P?4:5})});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(o({type:3,panelId:u}),()=>{o({type:3,panelId:null})}),[u,o]);let i=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .useOpenClosed */ .oJ)(),p=(()=>i!==null?i===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Open */ .ZM.Open:t.disclosureState===0)(),D=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.disclosureState===0,close:f}),[t,f]),d={ref:s,id:u};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(H.Provider,{value:t.panelId},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:d,theirProps:T,slot:D,defaultTag:le,features:re,visible:p,name:"Disclosure.Panel"}))}),Le=Object.assign(ee,{Button:ne,Panel:oe});


/***/ })

}]);